import { ModalidadeConvenioTipo } from "./modalidade-convenio-tipo";

export class ApetiteRiscoModalidade {
    constructor(
        public apetiteRiscoId: number = null,
        public modalidadeConvenioTipo: ModalidadeConvenioTipo = null
    ) { }
}
